import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    jwt: null,
    user: null,
    status: "no-authenticated",
    errorMessage: null,
  },
  reducers: {
    loginAction: (state, action) => {
      state.errorMessage = null;
      state.user = action.payload.user;
      state.jwt = action.payload.token;
      state.status = "authenticated";
    },
    logoutAction: (state) => {
      state.user = null;
      state.jwt = null;
      state.status = "no-authenticated";
      state.errorMessage = null;
    },
    checkingCredentialsAction: (state) => {
      state.status = "checking";
      state.errorMessage = null;
    },
    errorMessageAction: (state, action) => {
      state.status = "no-authenticated";
      state.errorMessage = action.payload;
    },
    errorMessageNullAction: (state) => {
      state.status = "no-authenticated";
      state.errorMessage = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loginAction,
  logoutAction,
  checkingCredentialsAction,
  errorMessageAction,
  errorMessageNullAction,
} = authSlice.actions;
